import { SelectValue } from 'antd/lib/select';
import { ReactNode } from 'react';

import { ProviderModel, ProviderModelType } from '../../../gamma-api';

const VALUE_SEPARATOR = '_';

const buildModelSelectorOptionLabel = (providerTitle?: string | null, modelName?: string | null): string =>
  `${providerTitle} / ${modelName}`;

const buildModelSelectorOptionValue = (providerId: string, modelName: string): string =>
  `${providerId}${VALUE_SEPARATOR}${modelName}`;

export const buildModelSelectorValue = (providerId?: string | null, modelName?: string | null): string | undefined =>
  providerId && modelName ? buildModelSelectorOptionValue(providerId, modelName) : undefined;

export const buildModelSelectorOptions = (
  providers: ProviderModel[],
  type: ProviderModelType
): { value: string; label: ReactNode }[] => {
  const options = [] as { value: string; label: ReactNode }[];

  for (const provider of providers) {
    if (!provider.enabled) {
      continue;
    }

    for (const model of provider.settings?.models || []) {
      if (model.type == type) {
        options.push({
          value: buildModelSelectorOptionValue(provider.provider_id, model.name),
          label: buildModelSelectorOptionLabel(provider.title, model.name),
        });
      }
    }
  }

  return options;
};

export const parseModelSelectorValue = (value: SelectValue): [string, string] => {
  const [providerId, modelName] = (value as string).split(VALUE_SEPARATOR);
  return [providerId, modelName];
};
